import Vue from 'vue';
import infiniteScroll from 'vue-infinite-scroll';
import vueDebounce from 'vue-debounce';
import VueGtag from 'vue-gtag';

import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import i18n from './i18n';
import vuetify from './plugins/vuetify';

import classMode from './mixins/classMode';
import imageUrlMixin from './mixins/imageUrl';
import localizedMixin from './mixins/localized';
import trackMixin from './mixins/track';

import Uppercase from './directives/uppercase';
import Focus from './directives/focus';

import firebase from './firebase';

// Globally register all `Base` prefixed components
import './components/_globals';

Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GTAG_ID,
  },
}, router);

// If we're in a compiled app, fallback into GA3
if (process.env.VUE_APP_BUILD_TARGET === 'app') {
  window.ga('create', process.env.VUE_APP_GTAG_ID, 'auto');
  window.ga('set', 'checkProtocolTask', () => {});

  router.afterEach((to) => {
    window.ga('send', 'pageview', to.name);
  });
}

Vue.use(infiniteScroll);
Vue.use(vueDebounce);
Vue.use(Uppercase);
Vue.use(Focus);

Vue.mixin(localizedMixin);
Vue.mixin(imageUrlMixin);
Vue.mixin(classMode);
Vue.mixin(trackMixin);

Vue.config.productionTip = false;

function init() {
  new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: (h) => h(App),
  }).$mount('#app');
}

// Initialize firebase auth
firebase.auth().onAuthStateChanged(async (a) => {
  if (!a) {
    await store.dispatch('session/anonymousLogin');
    // router.push
  } else {
    await store.dispatch('session/auth');
  }

  init();

  // if (a) {
  //   await store.dispatch('session/auth');
  // }

  // new Vue({
  //   router,
  //   store,
  //   i18n,
  //   vuetify,
  //   render: (h) => h(App),
  // }).$mount('#app');
});
